import {useState, useEffect} from "react";
import { motion, AnimatePresence } from "motion/react"


function Carousel(props){

    const [index, setIndex] = useState(0);

    useEffect(() => {
        
    // eslint-disable-next-line
    },[props.children])

    const goPrev = () => {
        setIndex( 
            (index > 0) ? index-1 : 0 
        );
    }

    const goNext = () => {
        setIndex(
            (index < props.children.length-1) ? index+1 : props.children.length-1
        );
    }

    return (
        <div className="carousel">

            <div className="carousel__navi">
                
                <button 
                    className={`carousel__navi-prev`}
                    disabled={index===0}
                    onClick={() => goPrev()}
                >
                    prev
                </button>
                
                <span>
                    {index+1} / {props.children.length}
                </span>

                <button 
                    className={`carousel__navi-next`} 
                    disabled={index===props.children.length-1}
                    onClick={() => goNext()}
                >
                    next
                </button>

            </div>

            <AnimatePresence>
                <div className="carousel__content">
                    { props.children
                        .filter( (_,idx) => idx === index )
                        .map( (item, itemIdx) => 
                            <motion.div 
                                key={`carousel_itm_${itemIdx}`}
                                className=""
                                initial={{ 
                                    // y: '50px',
                                    opacity: 0
                                }}
                                animate={{
                                    // y: '0px',
                                    opacity: 1,
                                    transition: { 
                                        stiffnes: .2,
                                        duration: .4,
                                        ease: [0, 0.11, 0.2, 1.01],
                                    }
                                }}
                                exit={{
                                    opacity: 0,
                                    // y: '-50px',
                                    transition: {
                                        duration: .32,
                                    }
                                }}
                            >
                                {item}
                            </motion.div>
                        ) 
                    }
                </div>
            </AnimatePresence>

            
        </div>
    );

}

export default Carousel;